export default {
    title_challenge: 'Challenges',
    read_following_text_award: 'By reading the following text you will get',
    by_correct_answer: 'by correct answer',
    beeCoins_perfect_result: 'BeeCoins for perfect result',
    finishReading: 'Finish reading',
    done: 'DONE',
    nowToTheQuestions: 'Now QUIETLY we go with the questions',
    goToQuestions: 'Go to questions',
    sendAnswers: 'Send answers',
    mustAnswerTheQuestions: 'You must answer the questions',
    tooFast: 'TOO FAST',
    fast: 'FAST',
    medium: 'MEDIUM',
    youCanImprove: 'Cheer up! You can get better',
    closeKeepTrying: '¡Oops, almost! Keep trying',
    wellDone: '¡Well done! ¡Great!',
    findYourMistakes: 'Find your mistakes',
    lastChance: 'Last chance',
    getReward: 'Get reward',
    readingSpeed: 'Reading Speed',
    youRead: 'You read',
    words: 'words',
    byMinute: 'by minute',
    yourReadingLevel: 'Your reading level is',
    comprehension: 'Comprehension',
    correctAnswers: 'Correct Answers',
    incorrectAnswers: 'Incorrect Answers',
    fantastic: '¡Fantastic!',
    youHaveWon: "You've won",
    doAnotherChallenge: 'Do another challenge',
    goHome: 'Go home',
    initial_challenge_title: 'Challenge',
    initial_text_you_will_get:
        'You have the mission to read a short text and answer 4 questions. Answer everything correctly and get one of the rewards that we show you below.',
    initial_text_points: 'points',
    initial_text_button: 'Start this challenge',
    initial_card_title_1: 'Before starting this challenge, you should know that:',
    initial_card_title_2: 'There are 3 levels of reading comprehension:',
    initial_card_title_3: '',
    initial_card_text_1: 'When we understand a text we build a new knowledge from the information that the text gives us and the information that is in our brain.',
    initial_card_text_2:[
        'Literal level: go to the information is in the text.',
        'Inferential level: going to the information is in the text and in us.',
        'Evaluative level: going beyond the information presented by the text, integrating knowledge, evaluations and judgments.',
    ],
    initial_card_text_3:
        'The text below has questions that will challenge you, so read carefully.',
    text_next: 'Next',
    text_back: 'Back',
    resolve_challenge: 'Send challenge',
    success_msg: 'As you have answered correctly, you earn the following:',
    new_challenge: 'New challenge',
    very_well_done: 'Very well done!',
    please_try_again: 'Please try again!',
    try_again_msg_2: 'You still have time to improve your reading skills. Do not give up!',
    excellent_work_mission_accomplished: 'Excellent work, mission accomplished',
    result_msg_0: 'Don\'t be afraid to make mistakes. Keep practicing, and you\'ll see improvement with each attempt.',
    result_msg_1: 'You still have time to improve your reading skills. Don\'t give up!',
    result_msg_2: 'You still have time to improve your reading skills. Don\'t give up!',
    result_msg_3: 'Keep practicing your reading skills and discovering new texts.',
    result_msg_4: 'You answered all the questions correctly. Keep it up, you\'re on the path to reading success!',
    title_msg_0: 'Try again!',
    title_msg_1: 'Keep striving!',
    title_msg_2: 'Don\t get discouraged!',
    title_msg_3: 'Almost perfect!',
    title_msg_4: 'Excellent job!',
    your_rewards: 'Your rewards',
    collect_prize: 'Collect prize',
    result: 'Result',
    font: 'Font',
    text_size: 'Text size',
    do_not_be_discouraged: 'Do not be discouraged',
    fail_msg: 'This time you have managed to win the following:',
    prize_breakdown: 'How many points and BeeCoins can I earn ?,',
    you_win: 'Correct answers you will win',
    win4: '20 points and 20 BeeCoins',
    win3: '15 points and 4 BeeCoins',
    win2: '10 points and 3 BeeCoins',
    win1: '5 points and 2 BeeCoins',
    try_again_msg: 'Focus a little more and try again.',
    go_to_questions: 'Go to questions',
    rewards: 'rewards',
    correct_answers: 'Correct answers',
    beginning_initial_challenge_title: 'Challenges',
    beginning_initial_challenge_set_question_option: 'Choose if you want the questions with:',
    beginning_initial_challenge_premessage_text: 'Your goal is read and answer the questions about the stories.',
    beginning_initial_challenge_question_option_words: 'Words',
    beginning_initial_challenge_question_option_images: 'Images',
    take_a_challenge_and_earn_rewards: 'Take a challenge and earn rewards',
    test_your_reading_skills: 'Test your reading skills',
    start_challenge: 'Start challenge',
    details: 'Details',
    duplicate_submission_error: 'This challenge has already been completed. Duplicate submissions are not allowed.',
}
